import { useQuery } from "@tanstack/react-query";
import { queryRoots, api } from "@/shared/api";

export type UsageScope = "mine" | "all";
export const usageKeys = {
  all: queryRoots.usage,
  scope: (s: UsageScope | undefined) => [...usageKeys.all, s ?? "default"] as const,
};

export function useStorageUsage(scope?: UsageScope) {
  return useQuery({
    queryKey: usageKeys.scope(scope),
    queryFn: async ({ signal }) => {
      const { data } = await api.GET("/storage/usage", { params: { query: { scope } }, signal });
      if (!data) throw new Error("Empty usage response");
      return data;
    },
  });
}
